import React from 'react'
import { observer } from 'mobx-react'
import styled from 'styled-components'
import ReactModal from 'react-modal'

import useInject from '~/hooks/useInject'
import Spacer from '~/components/Spacer'
import WinItButton from "~/components/WinItButton"
import Link from '~/components/Link'
import MODAL_STYLES from '~/components/modals/styles'

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`

const ModalTitle = styled.div`
  font-family: ${props => props.theme.fonts.avenirNextBold};
  font-size: 1.5em;
  text-align: center;
  max-width: 550px;
`

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  margin-top: .5em;
`

const mapStore = store => ({
  user: store.auth.user,
  isMobile: store.ui.isMobile
})

const DeletedModal = () => {
  const { user, isMobile } = useInject(mapStore)
  return (
    <ReactModal
      closeTimeoutMS={300}
      isOpen={user.accountDeleted}
      style={isMobile ? MODAL_STYLES.mobile.general : MODAL_STYLES.desktop.general}
      onRequestClose={() => {}}
    >
      <ModalContainer>
        <ModalTitle>
          This account has been deleted. If you need assistance, please contact customer support.
        </ModalTitle>
        <Spacer mobile={16} desktop={16} />
        {/* TODO: Empty link until new support page is created */}
        <Link href="">
          <ButtonContainer>
            <WinItButton
              color="green"
              width="100%"
              height={70}
              fontSize="1rem"
              type="submit"
              onClick={() => {}}
            >
              Contact Support
            </WinItButton>
          </ButtonContainer>
        </Link>
      </ModalContainer>
    </ReactModal>
  )
}

export default observer(DeletedModal)